const CHECKOUT_RESUME_KEY = 'tfd_checkout_resume';
const CHECKOUT_RESUME_TTL_MS = 2 * 60 * 60 * 1000;

export function saveCheckoutResume(payload) {
  try {
    localStorage.setItem(CHECKOUT_RESUME_KEY, JSON.stringify({
      ...payload,
      flow: 'checkout',
      updated_at: Date.now(),
    }));
  } catch {}
}

export function readCheckoutResume() {
  try {
    const raw = localStorage.getItem(CHECKOUT_RESUME_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.updated_at || (Date.now() - parsed.updated_at) > CHECKOUT_RESUME_TTL_MS) {
      localStorage.removeItem(CHECKOUT_RESUME_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function updateCheckoutResume(updates) {
  const current = readCheckoutResume() || { flow: 'checkout' };
  saveCheckoutResume({ ...current, ...updates });
}

export function clearCheckoutResume() {
  try {
    localStorage.removeItem(CHECKOUT_RESUME_KEY);
  } catch {}
}